import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Printer } from "lucide-react";
import { usePack } from "@/hooks/usePack";
import { LogoMark } from "@/components/Logo";

const Block = ({ b }) => {
  if (b.kind === "lines") return (
    <div className="mt-7"><p className="font-semibold">{b.heading}</p>
      {Array.from({ length: b.count }).map((_, i) => <div key={i} className="h-9 border-b border-[#bfae98]" />)}
    </div>
  );
  if (b.kind === "checklist") return (
    <div className="mt-7"><p className="font-semibold mb-2">{b.heading}</p>
      {b.items.map((it, i) => <div key={i} className="flex items-center gap-3 h-9 border-b border-[#e3d6c4]"><span className="w-4 h-4 border-2 border-[var(--ink)] rounded" />{it}</div>)}
    </div>
  );
  return (
    <div className="mt-7"><p className="font-semibold mb-2">{b.heading}</p>
      <table className="w-full border-collapse text-sm">
        <thead><tr>{b.columns.map((c) => <th key={c} className="text-left border border-[#bfae98] bg-[var(--cream-2)] p-2">{c}</th>)}</tr></thead>
        <tbody>{b.rows.map((r, i) => (
          <tr key={i}>{b.columns.map((c, j) => <td key={c} className="border border-[#bfae98] p-2 h-10">{j === 0 ? r : ""}</td>)}</tr>
        ))}</tbody>
      </table>
    </div>
  );
};

export default function Planner() {
  const { id } = useParams();
  const [pack] = usePack();
  if (!pack) return <p className="p-10">Cargando…</p>;
  const p = pack.planners.find((x) => x.id === id);
  if (!p) return <p className="p-10">Planificador no encontrado.</p>;

  return (
    <main data-testid="planner-page" className="px-5 sm:px-8 py-8 max-w-3xl mx-auto">
      <div className="no-print flex justify-between items-center mb-6">
        <Link to="/pack" data-testid="planner-back-link" className="inline-flex items-center gap-1.5 hover:underline"><ArrowLeft size={16} /> Volver al pack</Link>
        <button data-testid="planner-print-button" onClick={() => window.print()} className="btn-accent"><Printer size={18} /> Imprimir o guardar PDF</button>
      </div>
      <div className="print-sheet bg-white rounded-[2rem] p-6 sm:p-10 border-2 border-[var(--ink)]">
        <p className="font-hand text-2xl text-[var(--terra)] inline-flex items-center gap-2"><LogoMark size={26} /> {pack.product_name} · En Dos Mundos</p>
        <h1 className="font-display text-3xl sm:text-4xl">{p.title}</h1>
        <p className="text-[#5a4f46] mt-2">{p.subtitle}</p>
        {p.blocks.map((b, i) => <Block key={i} b={b} />)}
      </div>
    </main>
  );
}
